import React, { useState, useEffect } from "react";
import NavBar from "../../nav/nav-bar";
import Header from "../../header/header";
import ReportNav from "../report-nav";
import Footer from "../../footer/footer";
import Service from "../../webservice/http";
import { debounce } from "lodash";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom";
import config from "../../config";
import Pagination from "../../components/pagination";
import { storage } from "../../utils/storage";

function Deviance() {
  const tableHeadingArray = [
    " Call Date",
    "Call Reference",
    "Customer Name",
    "Product",
    "Agent",
    "Call Language",
    "Manager",
    "Review",
    "Action",
  ];

  const services = new Service();
  const history = useHistory();
  const [tabledata, setTabledata] = useState([]);
  const [search, setSearch] = useState("");
  const [Loading, setLoading] = useState(false);
  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  async function Dashbaorddata() {
    setLoading(true);

    let url = `api/call_verification/deviance_analysis_calls/`;

    if (search) {
      url = url + `?search=${search}`;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const page = queryParams.get("page");

    if (page === null) {
      url = url + (search ? `&page=${1}` : `?page=${1}`);
    } else {
      url = url + (search ? `&page=${page}` : `?page=${page}`);
    }

    await services.get(url).then((res) => {
      setTabledata(res?.data);
      setLoading(false);
      setTotalpage(res?.pagination?.page_numbers);
      setTotalresult(res?.pagination?.total_results);
    });
  }

  const debouncedSearch = debounce((value) => {
    setSearch(value.toLowerCase());
  }, 500);

  const downloadReport = async function () {
    let downloadUrl = `${config.API_BASE_URL}/api/call_verification/download_editable_dasboard/`;

    if (search) {
      downloadUrl = downloadUrl + `?search=${search}`;
    }

    try {
      const response = await axios.get(downloadUrl, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${storage.getItem("access_token")}`,
        },
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "dashboard_data.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    Dashbaorddata();
  }, [search, currentPage]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    history.push(`/reports/deviance-analysis/?page=${pageNumber}`);
  };

  return (
    <div>
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid" style={{ background: "#EEF2F5" }}>
          <div className="my-call bg-white">
            <div
              className="side-panel-with-table clearfix flex"
              style={{ display: "flex" }}
            >
              <ReportNav />
              <div className="call-table" style={{ marginBottom: "80px" }}>
                <div
                  className="my-calls-column"
                  style={{ padding: "15px 0px 0px 15px" }}
                >
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i
                              className="fa fa-snowflake-o"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="pannel-heading-info">
                            <h3>Deviance Case Analysis</h3>
                            <p> Details</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" flex justify-end  my-10 items-center gap-4 px-6">
                  <input
                    onChange={(event) => debouncedSearch(event.target.value)}
                    type="text"
                    placeholder="Search..."
                    className="search-tag"
                    style={{
                      border: "none",
                      background: "#eef2f5",
                      borderRadius: "10px",
                      width: "250px",
                      outline: "none",
                      paddingLeft: "8px",
                      height: "35px",
                    }}
                  />
                  <button
                    className={` text-white px-8 py-2 rounded-xl export-btn tracking-wide ${
                      !tabledata?.length ? " opacity-60" : ""
                    }`}
                    disabled={!tabledata?.length}
                    onClick={downloadReport}
                  >
                    Export
                  </button>
                </div>

                <div className=" overflow-x-scroll">
                  <table className="ss" style={{ border: "1px solid grey" }}>
                    <tr id="black-line">
                      {tableHeadingArray
                        .filter((item) => {
                          const userRole = storage.getItem("role");
                          if (
                            (userRole === "Agent" || userRole === "Agenth") &&
                            item === "Action"
                          ) {
                            return false;
                          }
                          return true;
                        })
                        .map((item) => (
                          <th
                            key={item}
                            className="left-0 bg-white border-b-2 border-gray-200 px-5 py-4 text-left text-xl font-semibold tracking-wider text-black"
                          >
                            {item}
                          </th>
                        ))}
                    </tr>

                    <tbody>
                      {Loading && (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            <ClipLoader color="#2056FF" size="50px" />
                          </td>
                        </tr>
                      )}

                      {tabledata.length ? (
                        tabledata.map((e, i) => {
                          return (
                            <tr
                              key={i}
                              className=" cursor-pointer hover:bg-gray-100 transition-colors"
                              onClick={() =>
                                history.push(`/detailed-reports/${e.id}`)
                              }
                            >
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-no-wrap text-center text-sky-700">
                                  {e.call_date}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900 ">
                                  {e.call_reference}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.customer_name}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-no-wrap text-left text-gray-900">
                                  {e?.product}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.agent}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {e?.language}
                                </p>
                              </td>
                              <td className="border-b border-gray-200 px-5 py-2 text-xs whitespace-nowrap">
                                <p className="text-left text-gray-900">
                                  {e?.team_lead}
                                </p>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2   text-xs sticky left-0 `}
                              >
                                <div className="flex justify-start items-center ml-4">
                                  {e?.call_reviewed ? (
                                    <p
                                      className="font-bold"
                                      style={{
                                        color: "green",
                                        fontSize: "16px",
                                      }}
                                    >
                                      <i
                                        className="fa fa-check-circle"
                                        aria-hidden="true"
                                      ></i>
                                    </p>
                                  ) : (
                                    <p
                                      className="font-bold"
                                      style={{ color: "red", fontSize: "16px" }}
                                    >
                                      <i
                                        className="fa fa-times-circle"
                                        aria-hidden="true"
                                      ></i>
                                    </p>
                                  )}
                                </div>
                              </td>
                              {storage.getItem("role") !== "Agent" &&
                                storage.getItem("role") !== "Agenth" && (
                                  <td className="border-b border-gray-200 text-xs cursor-pointer w-40">
                                    <span className=" flex justify-center items-center mr-12 relative">
                                      <button
                                        className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                                        style={{
                                          border: "1px solid lightgray",
                                          padding: "10px 15px",
                                          borderRadius: "10px",
                                          cursor: "pointer",
                                        }}
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          history.push(
                                            `/detailed-reports/${e.id}`,
                                            { isEdit: true },
                                          );
                                        }}
                                      >
                                        Edit
                                      </button>
                                    </span>
                                  </td>
                                )}
                            </tr>
                          );
                        })
                      ) : Loading ? (
                        ""
                      ) : (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            No Record Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalpage?.length}
                    onPageChange={handlePageClick}
                    totalresult={totalresult}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Deviance;
